import SectionHeader from "../SectionHeader";
// import ChangeOrderTable from "../ChangeOrderTable";
import TableSkeleton from "Components/Common/Skeleton/TableSkeleton";
import ChangeOrderPage from "Pages/GcPrecon/ChangeOrder/pages/ChangeOrderPage";

interface ChangeOrderSummary {
  approved: string;
  pending: string;
  revised: string;
  onSubmit: () => void;
}

interface ChangeOrdersSectionProps {
  isActive: boolean;
  // rows: Parameters<typeof ChangeOrderTable>[0]["rows"];
  summary: ChangeOrderSummary;
  projectStage?: string;
  loading: boolean;
  onProjectedContractChange?: (value: number) => void;
}

const ChangeOrdersSection = ({
  isActive,
  // rows,
  summary,
  projectStage,
  loading,
  onProjectedContractChange,
}: ChangeOrdersSectionProps) => {
  const canCreateChangeOrder = projectStage === "construction";

  return (
    <div
      className={`section ${isActive ? "active" : ""}`}
      id="sec-change-orders"
    >
      {/* <SectionHeader
        title="Change Orders"
        subtitle="Submit change orders for any scope, schedule, or budget changes. The project owner approves directly — CSC is notified for record-keeping."
      /> */}
      {!canCreateChangeOrder && (
        <div className="actionAlert">
          <p className="aaTitle">
            ⚠️{" "}
            {projectStage === "completed"
              ? "This project has been completed. No further draw requests can be submitted."
              : "Draw request inspection is pending. You cannot create a change order until the draw request resolved."}
          </p>
        </div>
      )}
      {loading ? (
        <TableSkeleton cols={6} rows={4} />
      ) : (
        <>
          <ChangeOrderPage
            disabled={!canCreateChangeOrder}
            onProjectedContractChange={onProjectedContractChange}
          />
          {/* <ChangeOrderTable
            rows={rows}
            onSubmit={summary.onSubmit}
            canCreateChangeOrder={canCreateChangeOrder}
          /> */}
        </>
      )}

      {!loading && (
        <div className="summaryBar">
          <span>
            Approved COs to date:{" "}
            <strong className="coAmtNeg">{summary.approved}</strong>
          </span>
          <span>
            Pending approval:{" "}
            <strong className="coAmtPending">{summary.pending}</strong>
          </span>
          <span>
            Revised contract if all approved:{" "}
            <strong className="coAmtApprove">{summary.revised}</strong>
          </span>
        </div>
      )}
    </div>
  );
};

export default ChangeOrdersSection;
